import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { BreadcrumbBuilder } from '../../../../shared/ui/breadcrumb/breadcrumb-builder';
import { AdminUrlBuilder } from '../../../../shared/admin/api/admin-url-builder';
import { AbstractPresetListComponent } from '../preset-list.component';
import { EventBus } from '../../../../shared/event/bus';

@Component({
  selector: 'admin-product-list',
  templateUrl: './list.component.html',
  styleUrls: [ './list.component.scss' ]
})
export class AdminProductListComponent extends AbstractPresetListComponent implements OnInit, AfterViewInit {

  constructor(httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              route: ActivatedRoute,
              urlBuilder: AdminUrlBuilder,
              eventBus: EventBus,
              changeDetector: ChangeDetectorRef,
              private breadcrumbBuilder: BreadcrumbBuilder) {
    super(httpClient, toastrService, router, route, urlBuilder, eventBus, changeDetector);
  }

  ngOnInit(): void {
    this.breadcrumbBuilder.clear();
    this.breadcrumbBuilder.add({
      label: 'Admin / Products',
      url: '/admin/products'
    });
    this.parameters.orderBy = 'orderNumber';
    this.parameters.orderDir = 'asc';
    this.parameters.conditions.photoProduct = true;

    super.ngOnInit();
  }

  ngAfterViewInit(): void {
  }

  protected getResourceUrl(): string {
    return '/product';
  }

  onAdd() {
    const newRow = {
      id: undefined,
      name: 'Name',
    };
    this.pagination.rows.unshift(newRow);
  }

  onDelete(rowId) {
    this.delete(rowId);
  }

  drop($event) {
    console.log($event);
  }
}
